import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { IFilterData } from '@design-system/components/m-text-field';
import { TaxonomyTab } from '../../../models/TaxonomyTab';
import { FadeInAnimator } from '@libs/common-animations';
import { TaxonomyUiConstants } from '../../../taxonomy-ui/taxonomy-ui.constants';

@Component({
  selector: 'lib-taxonomy-campaign-view-column-header',
  templateUrl: './campaign-view-column-header.component.html',
  styleUrls: ['./campaign-view-column-header.component.scss'],
  animations: [FadeInAnimator.fade(TaxonomyUiConstants.defaultDurationInMillis)]
})
export class CampaignViewColumnHeaderComponent implements OnChanges {
  @Input() header = '';
  @Input() headerStyleClass = '';
  @Input() headerStyle: Record<string, string> = {};
  @Input() sort: { sortBy: string; sortOrder: string } | null = null;
  @Input() filterData: IFilterData = {
    contain: [],
    exclude: []
  };

  @Input() activeTab: TaxonomyTab | null = null;
  @Input() showAiRecommendations = false;

  @Output() searchValueChange = new EventEmitter<IFilterData>();
  @Output() sortChange = new EventEmitter<{
    sortBy: string;
    sortOrder: string;
  }>();

  showSearchBox = false;
  shouldShowAiIcon = false;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filterData']) {
      this.filterData = changes['filterData'].currentValue;
    }

    // Update shouldShowAiIcon when relevant inputs change
    if (
      changes['activeTab'] ||
      changes['showAiRecommendations'] ||
      changes['header']
    ) {
      this.shouldShowAiIcon =
        this.showAiRecommendations &&
        this.activeTab === TaxonomyTab.unmapped &&
        ['tactic', 'channel', 'segment'].includes(this.header.toLowerCase());
    }

    this.cdr.detectChanges();
  }

  toggleSearchBox() {
    this.showSearchBox = !this.showSearchBox;
  }

  publishSearchValue(filterData: IFilterData) {
    this.showSearchBox =
      filterData.contain.length > 0 || filterData.exclude.length > 0;
    this.searchValueChange.emit(filterData);
  }

  public setSort(sortBy: string) {
    const sortOrder = this.sort?.sortOrder === 'desc' ? 'asc' : 'desc';
    this.sort = { sortBy, sortOrder };
    this.sortChange.emit(this.sort);
  }
}
